var React = require('react');

function ClosingCross (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.89551 1.07373L17.4519 16.6301","stroke":"#C6D7FF","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M2.54785 16.9265L18.1042 1.37016","stroke":"#C6D7FF","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":1})]);
}

ClosingCross.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = ClosingCross;

ClosingCross.default = ClosingCross;
